import { useQuery } from '@tanstack/react-query';
import useUser from '../global/useUser';
import { getBusinessServices } from '../../services/business';

function useGetBusinessServices() {
  const { user } = useUser();

  const isEnabled = !!user?.business?.id;

  const { data, isLoading, isFetching, isError, error, refetch } = useQuery({
    queryKey: ['businessServices', user?.business?.id, user?.userId],
    queryFn: async () => {
      if (!user?.business?.id) return null;
      const settings = await getBusinessServices(user?.business?.id);
      return settings;
    },
    enabled: isEnabled,
  });

  return {
    services: data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
    isEnabled,
  };
}

export default useGetBusinessServices;
